module.exports = __webpack_public_path__ + "static/media/video.a41a80d4.webm";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BushfireFront/video.webm
// module id = 195
// module chunks = 0